import { lazy } from "react";

export const ManageWritersAsync = lazy(() => import("./ManageWriters"));
